import React from "react";
import {
  Box,
  Flex,
  Link,
  Button,
  Text,
  HStack,
  Image,
  Container,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import vvLogo from "./../../img//vartaverse-logo.png";

const Header = () => {
  const navigate = useNavigate();

  return (
    <Box
      as="header"
      boxShadow="md"
      bg="gray.900"
      borderBottom="1px"
      borderColor="gray.700"
      py="4"
    >
      <Container maxW="container.xl">
        <Flex align="center" justify="space-between">
          <Link href="/" _hover={{ textDecoration: "none" }}>
            <HStack spacing={3} cursor="pointer">
              <Image
                src={vvLogo}
                alt="Vartaverse Logo"
                boxSize="40px"
                objectFit="contain"
              />
              <Text
                fontSize="xl"
                fontWeight="bold"
                color="white"
                _hover={{ color: "teal.400" }}
                transition="color 0.2s"
              >
                VartaVerse
              </Text>
            </HStack>
          </Link>

          <Button
            variant="outline"
            colorScheme="teal"
            onClick={() => navigate("/login")}
            borderColor="teal.400"
            color="teal.400"
            _hover={{ bg: "teal.400", color: "gray.900" }}
            _active={{ bg: "teal.500" }}
            size="md"
          >
            Login
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};

export default Header;
